import { render, staticRenderFns } from "./PerformAncesummary.vue?vue&type=template&id=0417aa42&scoped=true"
import script from "./PerformAncesummary.vue?vue&type=script&lang=js"
export * from "./PerformAncesummary.vue?vue&type=script&lang=js"
import style0 from "./PerformAncesummary.vue?vue&type=style&index=0&id=0417aa42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0417aa42",
  null
  
)

export default component.exports